import { entityAPI, logAPI } from "api/GenericAPI";
import { Flyer , FlyerLog } from "api/Interactions/InteractionsInterfaces";



export const flyerAPI = entityAPI<Flyer>("interactions", "flyers");
export const flyerLogAPI = logAPI<FlyerLog>("interactions", "flyers");
